import Link from "next/link";
import Image from "next/image";
import { toast } from "react-toastify";
import { useRouter } from "next/router";
import { useState, useEffect } from "react";
import { Box, Container, Grid, Stack, Typography, Button, Tabs, Tab, useTheme } from "@mui/material"

import auth from "src/lib/auth";
import LoanSliders from "./LoanSliders";
import Pages from "../../../../../constants/pages";
import Calc from "public/images/icons/calculator.png";
import MainCard from "src/components/common/main-card";
import mainServices from "../../../../../services/main";
import { CalculatedItems } from "./components/CalculatedItems"
import { useSelectProvider } from "src/services/new-facility";
import LoadingButton from "src/components/common/LoadingButton";

const CalcLoan = ({ isMobile = false }) => {
  const theme = useTheme()
  const router = useRouter()
  const [data, setData] = useState([])
  const layerId = router?.query?.creditLayerId || ""
  const { mutate, isPending } = useSelectProvider();
  const [activeOrgIndex, setActiveOrgIndex] = useState(0)

  const ContainerComponent = isMobile ? Box : Container

  // States
  const [refund, setRefund] = useState(0)
  const [swiperIndex, setSwiperIndex] = useState(0)

  useEffect(() => {
    getAllProviders()
  }, [])

  const getAllProviders = async () => {
    const response = await mainServices.getAllProvierFacilityBasedOnCalculator({
      params: {
        CreditLayerId: layerId
      }
    })
    if (response?.status === 200) {
      if (response?.data?.succeed) {
        setData(response.data.value || [])
      }
    }
  }


  if (!data) return <div></div>
  const currentOrg = data[activeOrgIndex]
  const providerFacilities = currentOrg?.providerFacilities || [];

  const selectedValue = { ...(providerFacilities[swiperIndex]?.detail[refund] || providerFacilities[swiperIndex]?.detail[0]) };

  const handleSelectedProvider = () => {
    if (auth?.user?.mobileNumber) {
      mutate(selectedValue?.providerFacilityId, {
        onSuccess: (res) => {
          if (res.succeed) {
            toast.success("تسهیلات با موفقیت انتخاب شد");
            router.push(`${Pages.WorkFlow}/${res?.value}`);
          } else {
            toast.error(res.message);
          };
        }
      });
    } else {
      toast.info("ابتدا وارد حساب کاربری خود شوید");
      router.push(Pages.Login);
    };
  };

  return (
    <ContainerComponent sx={isMobile ? { mt: 10 } : { mt: 5, p: 0.8 }} id='calculator'>
      <Stack direction='row' alignItems='center' spacing={1.5} mb={4} justifyContent={isMobile ? "center" : "initial"}>
        <Image src={Calc} alt='calc' width={25} />
        <Typography
          variant={isMobile ? "h5" : "h3"}
          fontWeight='bold'
          sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000000" }}
        >
          محاسبه گر اقساط
        </Typography>
      </Stack>

      <Tabs
        value={activeOrgIndex}
        onChange={(e, newIndex) => {
          setActiveOrgIndex(newIndex)
          setSwiperIndex(0)
          setRefund(0)
        }}
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
      >
        {data.map((org, i) => (
          <Tab key={org.organizationId} label={org.organizationName} />
        ))}
      </Tabs>

      <Grid container spacing={1} sx={{ minHeight: "20vh", justifyContent: "center", alignItems: "center" }}>
        <Grid item xs={isMobile ? 12 : 6} md={6}>
          <LoanSliders
            data={providerFacilities}
            isMobile={isMobile}
            onChange={(priceIndex, refundValue) => {
              setSwiperIndex(priceIndex)
              setRefund(refundValue)
            }}
          />
        </Grid>
        <Grid item xs={isMobile ? 12 : 6} md={6}>
          <MainCard shadow={0} sx={{ borderRadius: "25px", p: 3, px: isMobile ? 1.5 : 5 }}>
            <CalculatedItems data={providerFacilities} priceIndex={swiperIndex} refund={refund} />

            <Stack mt={4} direction='row' justifyContent='end' alignItems='center'>
              <LoadingButton
                // href={Pages.SelectFacility}
                // component={Link}
                onClick={handleSelectedProvider}
                size='large'
                fullWidth={isMobile}
                disableElevation
                variant='contained'
                loading={isPending}
                color='primary'
                sx={{ borderRadius: "10px", px: 8 }}
              >
                درخواست وام
              </LoadingButton>
            </Stack>
          </MainCard>
        </Grid>
      </Grid>
    </ContainerComponent>
  )
}
export default CalcLoan